module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_score2.e7ef0.png";